import Bowser from 'bowser';

/**
 * Check if the user agent is chrome
 */
export const isChrome = () => /Chrome/.test(getBrowserName());
export const isFirefox = () => /Firefox/.test(getBrowserName());
export const isSafari = () => /Safari/.test(getBrowserName());
export const isEdge = () => /Edge/.test(getBrowserName());
export const isIE = () => /Explorer/.test(getBrowserName());

export function getBrowserName() {
  return Bowser.parse(window.navigator.userAgent).browser.name;
}

export default {
  isChrome,
  isFirefox,
  isSafari,
  isEdge,
  isIE,
  getBrowserName,
};
